import { Alert, Button, Container, TextField } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from "react";
import { Backend } from "../../services/Backend";
import { SuccessToast } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";

export default function AdminSubmitNewsPage() {
    const navigate = useNavigate();

    const [error, setError] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [photoLink, setPhotoLink] = useState("");
    const [photo, setPhoto] = useState(null);

    const onSubmit = () => {
        if (!validateForm()) {
            return;
        }

        const body = new FormData();

        body.append("title", title);
        body.append("description", description);
        body.append("file", photo);

        Backend.postFormData('news', body)
        .then(res => {
            SuccessToast("Success");
            setTimeout(() => window.location.href = '/dashboard/news', 1000);
        });
    }

    const validateForm = () => {
        if (!title) {
            setError("Title is required");
            return false;
        }

        if (!description) {
            setError("Description is required");
            return false;
        }

        if (!photo) {
            setError("Photo is required");
            return false;
        }

        return true;
    }

    const onSelectFile = (e) => {
        if (e.target.files[0]) {
            setPhoto(e.target.files[0]);
            setPhotoLink(URL.createObjectURL(e.target.files[0]));
        }
    }

    const backHandler = (e) => {
        e.preventDefault();
        navigate(-1);
    }   

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4] }],
            [{ 'size': ['small', 'medium', 'large'] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}, {'align': [] }],
            ['link'],
            ['clean'],
        ],
    };

    return <Container maxWidth="lg" className="my-5">
        <Link to="#" onClick={backHandler}>Back</Link>
        <h1 className="text-2xl">Add news</h1>
        <br />

        {error && <Alert severity="error" className="my-3">{error}</Alert> }

        <div className="w-[100%]">
            <TextField margin="normal" required fullWidth label="Title" value={title} onChange={(e) => setTitle(e.target.value)}  />
            <ReactQuill theme="snow" modules={modules}  value={description} onChange={setDescription}  className="h-[300px] mb-20" />
            {photoLink && <img className="w-[50%] my-3" src={photoLink}/>}
            <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
            >
                Upload photo
                <input type="file" className="hidden" onChange={onSelectFile} />
            </Button>

            {photo != null ? <p className="mt-2">{photo.name}</p> : ""}
            
            <br />
            <Button
                
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onSubmit} > Add
            </Button>
        </div>
    </Container>
}